export default __webpack_public_path__ + "static/media/noteIcon.866bf544.svg";